import { debounce } from 'lodash';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import YtBtn from '../../assets/img/icon/YouTube_logo_03.png';
import NullPlayer from '../../assets/img/player/null.png';
import PlayerSlideModal from '../video/PlayerSlideModal';

function PlayerSlide({data,position, checked, profile}) {
    let [index, setIndex] = useState(0);
    let [btnState, setBtnState] = useState({left: false, right: true});
    let divBox = useRef();
    let prevRef = useRef();
    let nextRef = useRef();

    let basicWidth = 65;
    let lastIndex = data['length']-5;
    let firstIndex = 0;
    let recentIndex = 0;

    useEffect(() => {
        divBox.current.scrollTo({
            left: 0,
            behavior: 'smooth'
        });
    }, [checked])

    function slideEvent(event) {
        let btnId = event.target.id;

        let scrollWidth = divBox.current.scrollWidth;
        let clientWidth = divBox.current.clientWidth;
        let width = scrollWidth - clientWidth;

        let calcWidth = basicWidth+4;
        let scrollLeft = divBox.current.scrollLeft;

        if(lastIndex > 0) {
            if(( (scrollLeft === 0) && (btnId !== 'prevBtn') ) || 
            ( ( scrollLeft === width) && (btnId !== 'nextBtn') ) || 
            ( (scrollLeft !== 0) && (scrollLeft !== width) )) {
                nextRef.current.classList.add('active');
                prevRef.current.classList.add('active');
                if(btnId === 'nextBtn') {
                    if(scrollLeft%(calcWidth) === 0) { //click scroll
                        if(scrollLeft !== (width+calcWidth)) { // not end
                            divBox.current.scrollBy({
                                left: calcWidth,
                                behavior: 'smooth'
                            });
    
                            if((scrollLeft+calcWidth) === width) { //end
                                nextRef.current.classList.remove('active');
                            }
                        }
                    } else { // after wheel scroll
                        let remainder = scrollLeft%calcWidth;
                        let calcLeft = calcWidth-remainder;
    
                        divBox.current.scrollBy({
                            left: calcLeft,
                            behavior: 'smooth'
                        });
    
                        if((scrollLeft+calcLeft) === width) { //end
                            nextRef.current.classList.remove('active');
                        }
                    }
                } else { //prevButton
                    if(scrollLeft%(calcWidth) === 0) { //click scroll
                        if(scrollLeft !== 0) { // not start
                            divBox.current.scrollBy({
                                left: -(calcWidth),
                                behavior: 'smooth'
                            });
    
                            if((scrollLeft-calcWidth) === 0) { //start
                                prevRef.current.classList.remove('active');
                            }
                        }
                    } else { // after wheel scroll
                        let remainder = scrollLeft%calcWidth;
                        divBox.current.scrollBy({
                            left: -remainder,
                            behavior: 'smooth'
                        });
    
                        if((scrollLeft-remainder) === 0) { //start
                            prevRef.current.classList.remove('active');
                        }
                    }
                }
            } else { // start or end
                
            }
        }
    }

    function onErrorHandler(event) {
        event.target.src = NullPlayer;
    }

    function divScrollHandler(event) {
        let scrollLeft = event.currentTarget.scrollLeft;
        debouncedFunc(scrollLeft);
    }

    const debouncedFunc = useMemo(() => debounce((left) => {
        let scrollLeft = divBox.current.scrollLeft;
        let scrollWidth = divBox.current.scrollWidth;
        let clientWidth = divBox.current.clientWidth;
        let width = scrollWidth - clientWidth;

        let calcWidth = basicWidth+4;

        nextRef.current.classList.add('active');
        prevRef.current.classList.add('active');
        
        if((scrollLeft) === width) { //end
            nextRef.current.classList.remove('active');
        } else if(scrollLeft === 0) { //start
            prevRef.current.classList.remove('active');
        }
    }, 300), []);

    return (
    <div className="imageWrap">
        <div className="arrowLeft" onClick={slideEvent} id="prevBtn" ref={prevRef}></div>
        <div style={{
            display:'inline-block',width: '690px',
            overflowX: 'overlay', overflowY: 'hidden',
            whiteSpace: 'nowrap', 
        }} ref={divBox} onScroll={divScrollHandler}>
            <div>
                {data.map((item) => (
                    <div id={item['playerId']} className="imageBox" key={item['playerId']}
                    style={{width: `${basicWidth}px`, display:'inline-block', margin: '0px 2px'}}>
                        <PlayerSlideModal 
                            playerId={item['playerId']} 
                            playerName={item['playerName']}
                            playerEngName={item['englishPlayerName'] ? item['englishPlayerName'].replace(" ", "\n") : "#00" + "\n"+ item['playerName']}
                            teamId={item['teamId']} 
                            onErrorHandler={onErrorHandler} 
                            position={position} 
                            profile={profile}
                            checked={checked}
                        />
                    </div>
                ))}
            </div>
        </div>
        <div className="arrowRight active" onClick={slideEvent} id="nextBtn" ref={nextRef}></div>
    </div>
    )
}

export default PlayerSlide;